<template>
  <div class="resetPassword">
    <div class="form-wrapper">
      <div class="form-title">{{ $t('Reset Password') }}</div>
      <el-form :model="resetForm" label-position="top" status-icon :rules="rules" ref="resetForm" class="my-form" v-loading="fullLoading">
        <el-form-item :label="$t('staff id')" prop="number">
          <el-input v-model="resetForm.number" autocomplete="off" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
        </el-form-item>
        <el-form-item :label="$t('Phone No')" class="phone-col">
          <div class="phone-area">
            <el-form-item prop="phoneArea">
              <el-select v-model="resetForm.phoneArea" placeholder="">
                <el-option
                  v-for="item in phoneArea"
                  :key="item"
                  :label="item"
                  :value="item">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="phone-number">
            <el-form-item prop="phone">
              <el-input v-model="resetForm.phone" autocomplete="off" oninput="value=value.replace(/[^0-9.]/g,'')"></el-input>
            </el-form-item>
          </div>
          <div class="send-sms">
            <el-button plain type="primary" @click="sendSMS" :disabled="isDisabledSend">{{isDisabledSend ? showtime : $t('Send SMS')}}</el-button>
          </div>
        </el-form-item>
        <el-form-item :label="$t('Input Verification Code')" prop="sms_code">
          <el-input v-model="resetForm.sms_code" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item class="submitWrapper">
          <el-button type="primary" @click="submitForm()" class="submitBtn">{{ $t('RESET PASSWORD') }}</el-button>
        </el-form-item>
        <el-form-item class="link">
          <router-link :to="{name: 'Login'}">{{ $t('Back to login') }}</router-link>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      const validateNumber = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('Please input the Staff ID')))
        } else {
          callback()
        }
      }
      const validatePhone = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('Please input your phone number')))
        } else {
          callback()
        }
      }
      const validateCode = (rule, value, callback) => {
        if(value === '') {
          callback(new Error(this.$t('Please input verification code')))
        } else {
          callback()
        }
      }
      return {
        fullLoading: false,
        resetForm: {
          number: '',
          phone: '',
          phoneArea: '853',
          sms_code: '',
        },
        rules: {
          number: [
            {validator: validateNumber, trigger: 'blur'},
            {pattern:/^\d{8}$/,message: this.$t('Reset Between 6 and 20 characters')},
          ],
          phone: [
            {validator: validatePhone, trigger: 'blur'},
            {pattern:/^\d{7,15}$/,message:this.$t('Reset Between 7 and 15 characters')}
          ],
          sms_code: [
            {validator: validateCode, trigger: 'blur'},
            {pattern:/^\d{6}$/,message:this.$t('Six digits')}
          ],
        },
        isDisabledSend: false,
        timeout: 300,
        showtime: '00:00',
      };
    },
    methods: {
      sendSMS() {
        let isValidNumber = true
        let isValidPhoneArea = true
        let isValidPhone = true
        this.$refs.resetForm.validateField('number', (valid) => {
          valid ? isValidNumber=false : isValidNumber=true
        })
        this.$refs.resetForm.validateField('phoneArea', (valid) => {
          valid ? isValidPhoneArea=false : isValidPhoneArea=true
        })
        this.$refs.resetForm.validateField('phone', (valid) => {
          valid ? isValidPhone=false : isValidPhoneArea=true
        })
        if (isValidNumber == true && isValidPhoneArea == true && isValidPhone == true) {
          this.fullLoading = true
          const smsData = {
              account: this.resetForm.number,
              phone: this.resetForm.phone,
              area_code: this.resetForm.phoneArea,
            }
          this.axios.post('/api/employee/auth/sms', smsData)
            .then((res) => {
                if (res.code !== 200) {
                  this.$alert(res.msg, {
                      confirmButtonText: this.$t('CLOSE'),
                      center: true,
                  })
                }
                this.timeout = res.time || 0
                this.isDisabledSend = true
                this.countDown()
              }).finally(() => {
            this.fullLoading = false
          })
        }
      },
      countDown () {
        var timer = setInterval(() => {
          this.timeout -= 1
          let min = parseInt(this.timeout / 60)
          let sed = this.timeout % 60
          this.showtime = (min < 10 ? '0'+ min : min) + ':' + (sed < 10 ? '0' + sed : sed)
          if(this.timeout <= 0) {
            this.isDisabledSend = false
            clearInterval(timer)
          }
        }, 1000);

        return {
          cancel: () => clearInterval(timer)
        }
      },
      submitForm() {
        this.$refs.resetForm.validate((valid) => {
          if (valid) {
            this.fullLoading = true
            const resetValidData = {
              area_code: this.resetForm.phoneArea,
              phone: this.resetForm.phone,
              sms_code: this.resetForm.sms_code,
            }
            this.axios.post('/api/employee/auth/check-sms', resetValidData)
              .then((res) => {
                if (res.code === 200) {
                  this.$store.commit('stateChange', {k: 'resetForm', v: this.resetForm})
                  this.$router.push({name: 'ChangePassword'})
                } else {
                  this.$alert(res.msg, {
                      confirmButtonText: this.$t('CLOSE'),
                      center: true,
                  })
                }
              }).finally(() => {
              this.fullLoading = false
            })
          } else {
            return false;
          }
        });
      },
    },
    computed: {
      phoneArea(){
        return this.$store.state.phoneArea
      }
    }
  }
</script>
